import { Injectable } from '@angular/core';
import {MensagensService} from 'max-ng-lib';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import { GenericServicesMotoristaService } from './generic-services-motorista.service';
import { InformacaoExtrator } from '../content/pages/components/models/extrator/informacao-extrator';

@Injectable({
  providedIn: 'root'
})
export class ExtratorService extends GenericServicesMotoristaService {

  constructor(
    private mensagensService: MensagensService,
    private httpClient: HttpClient
  ) {
    super();
  }

  getMensagensService(): MensagensService {
    return this.mensagensService;
  }

  getHttpClient(): HttpClient {
    return this.httpClient;
  }

  getUrlRecurso(): string {
    return '/extrator';
  }


  obterDadosExtratorAndBanco(): Observable<InformacaoExtrator>  {
    return this.post('/obterStatusExtrator', {
      exibirLoading: false
    });
  }
}
